
import XTable from 'vux/src/components/x-table/index.vue'

import orderJS from './order.js'
export default {
components: {
XTable,
},
mixins: [orderJS],
props: ['activeIndex'],
data() {
return {
currentPage: 1,
pageSize: 10,
dataList: [],
lastPage: false,
scrollFlag: true,
statusList: ['', 'payWaiting', 'shipWaiting', 'receivWaiting', 'afterSale']
};
},
watch: {
activeIndex(val) {
this.doRefresh();
}
},
methods: {
/**
* type: 1赋值，2push
*/
loadList(type) {
let that = this;
let searchItem = {
currentPage: that.currentPage,
pageSize: that.pageSize,
shopperId: that.$store.state.userInfo.shopperId,
status: that.statusList[that.activeIndex]
};
that.$vux.loading.show({
text: '加载中...'
});
that.$axios
.get('/api/v1.0/lonbonShop/order', {
params: searchItem
})
.then(function(response) {
if (response.status == 200) {
var list = response.body.list.map(item => {
item.orderStatusStr = that.$store.state.dict.statusStrList[item.status].title;
item.createTimeStr = that.$moment(item.createTime * 1000).format('YYYY-MM-DD HH:mm:ss');
return item;
});
if (type == 1) {
that.dataList = list;
} else {
list.forEach(item => {
that.dataList.push(item);
});
}
} else if (response.status == 203) {
that.lastPage = true;
}
that.$vux.loading.hide();
})
.catch(function() {
that.$vux.loading.hide();
});
},
doNext() {
if (!this.lastPage) {
this.currentPage++;
this.loadList(2);
}
},
doRefresh() {
this.currentPage = 1;
this.loadList(1);
this.lastPage = false;
},

toOrder(id) {
this.$router.push('/mallOrderDetail?readyPayOrderId=' + id + '&activeIndex=' + this.activeIndex);
},

toOrderAndPay(id) {
this.$router.push('/mallOrderDetail?readyPayOrderId=' + id + '&openPay=true&activeIndex=' + this.activeIndex);
},

cancleOrder(one, index) {
let that = this;
that.cancleOrderFunc(one, function() {
if (that.activeIndex == 0) {
that.dataList[index].status = 9;
that.dataList[index].orderStatusStr = that.$store.state.dict.statusStrList[9].title;
} else {
that.dataList.splice(index, 1);
}
that.dataList = JSON.parse(JSON.stringify(that.dataList));
that.$emit("getOrderNum");
});
},

deleteOrder(one, index) {
let that = this;
that.deleteOrderFunc(one, function() {
that.dataList.splice(index, 1);
that.dataList = JSON.parse(JSON.stringify(that.dataList));
that.$emit("getOrderNum");
});
},

sureTake(one, index) {
let that = this;
that.sureTakeFunc(one, function() {
if (that.activeIndex == 0) {
that.dataList[index].status = 3;
that.dataList[index].orderStatusStr = that.$store.state.dict.statusStrList[3].title;
} else {
that.dataList.splice(index, 1);
}
that.dataList = JSON.parse(JSON.stringify(that.dataList));
that.$emit("getOrderNum");
});
}
},
mounted() {
this.doRefresh();
let that = this;
$(".middle").scroll(function() {
if(that.$route.path == '/mallMine') {
var nDivHight = $(this).height();
var nScrollHight = $(this)[0].scrollHeight;
var nScrollTop = $(this)[0].scrollTop;
if (nScrollTop + nDivHight + 1 >= nScrollHight) {
if(that.scrollFlag) {
that.doNext();
that.scrollFlag = false;
setTimeout(() => {
that.scrollFlag = true;
}, 1500)
}
}
} else {
$('.middle').unbind("scroll");
}
});
},
beforeDestroy() {
$('.middle').unbind("scroll");
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/orderList.vue